import { RestClient } from '../lib/RestClient'

class AnexoService extends RestClient {
  constructor() {
    super('anexos')
  }

  getURL(url, escola) {
    return this.request({
      method: 'GET',
      url: `urlTemp?url=${url}&escola=${escola}`
    })
  }

  deteleFile(params) {
    return this.request.delete('', { params })
  }
}

export const Anexos = new AnexoService()
